export default __webpack_public_path__ + "static/media/noise_original.0473ebbb.png";